import React, { useEffect, useState } from 'react';
import {
  Grid,
  Typography,
  Box,
  Container,
  Stack,
  IconButton,
  MenuItem,
  alpha,
  Menu,
  styled,
} from '@mui/material';
import { doc, getDoc } from 'firebase/firestore';
import { useNavigate, useParams } from 'react-router-dom';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { UserAuth } from '../../../../context/AuthContext';
import { useSnackbar } from '../../../../context/snackbarContext';
import { db } from '../../../../firebase.config';
import Page from '../../../../components/Page';
import CustomButton from '../../../../components/CustomButton';
import Sum from './components/shwoPaidCampaignComponent/sum';
import Perfs from './components/shwoPaidCampaignComponent/perfs';
import LucideIcon from '../../../../components/LucideIcon';

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 5,
    marginTop: theme.spacing(1),
    minWidth: 200,
    color: theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 15,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
      },
    },
  },
}));

const CampaignDashboard = () => {

  const { campaignID } = useParams();
  const [campaignDetailsId, setCampaignDetailsId] = useState(null);
  const { user, userData } = UserAuth();
  const showSnackbar = useSnackbar()
  const navigate = useNavigate()
  const [token, setToken] = useState();
  const [fbData, setFbData] = useState();
  const [fbCampagneData, setFbCampagneData] = useState();
  const [selectedAdAccount, setSelectedAdAccount] = useState(null);
  const [selectedPage, setSelectedPage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [currency, setCurrency] = useState('');
  const [media, setMedia] = useState(null)
  const [text, setText] = useState("✨ Join us for an unforgettable night at the test event! 🌜 Get ready to dance the night away and make memories that will last a lifetime.Mark your calendars for Saturday, June 7th at 3:00 AM at the stunning 12 Via des Cerises venue. Don’t miss out on this epic event - get your tickets now! 🎉 #test #partytime #nightlife");
  const [titleLink, setTitleLink] = useState('');
  const [linkDesc, setLinkDesc] = useState("Reserver sur Choptonticket!");
  const [btText, setBtText] = useState('Acheter vos tickets');
  const [age, setAge] = useState({ min: 17, max: 35 });

  const [gender, setGender] = useState('');

  const [type, setType] = useState(0);
  const [budget, setBudget] = useState(0);
  const [typeBudget, setTypeBudget] = useState(0);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectedInterst, setSelectedInterest] = useState([]);

  // const { hideNavbar, setHideNavbar } = Variables()

  const [dateDebut, setDateDebut] = useState(null);
  const [timeDebut, setTimeDebut] = useState('all');


  const [dateFin, setDateFin] = useState(null);
  const [timeFin, setTimeFin] = useState('');

  const handleTimestamp = (e) => {
    const date = e.toDate();
    return format((new Date(date.toJSON())), 'yyyy-MM-dd', { locale: fr }).toString();
  };

  const handleTimestampCustom = (e) => {
    const date = e.toDate();
    const tmp = date.toJSON().split('.')[0].split('T')[1].split(':');
    return format((new Date(date.toJSON())), 'HH:mm', { locale: fr }).toString();
  };
  const { clicks = 0, impressions = 0, cpc = 0, spend = 0 } = { clicks: 10, impressions: 20, cpc: 30, spend: 40 };

  const remainingBudget = budget - spend;
  const clickEstimate = budget / (cpc || 0.01);
  const performance = clicks / clickEstimate;

  // 🎯 Suggestion automatique
  const getSuggestion = () => {


  };

  const suggestion = getSuggestion();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [campagneType, setCampagneType] = React.useState(1);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [openMenu, setOpenMenu] = useState(false);
  const handleOpenMenu = (event, index) => {
    setSelectedIndex(index);
    setAnchorEl(event.currentTarget);
    setOpenMenu(true);
  };
  const handleCloseMenu = (e) => {

    setAnchorEl(null);
    setOpenMenu(false);
  };


  useEffect(() => {
    (async () => {
      try {
        setLoading(true);

        const docRef0 = doc(db, 'organisateurs', `${user.uid}`);
        const docSnap = await getDoc(docRef0);
        // recuperation de la campagne
        const docRefCampaign = doc(db, `organisations/${docSnap.data().idOrg}/crm/${docSnap.data().idOrg}/paidCampains`, `${campaignID}`);
        const docSnapCampaign = await getDoc(docRefCampaign);
        if (docSnapCampaign.exists()) {
          const campaign = docSnapCampaign.data();
          console.log(campaign)
          setCampaignDetailsId(campaign.campagnDetailsId);

        }
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
      setLoading(false);
    })();
  }, [user, userData, campaignID]);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        if (campaignDetailsId === null) {
          return
        }
        const docRefCampaign = doc(db, `paidCampains`, `${campaignDetailsId}`);
        const docSnapCampaign = await getDoc(docRefCampaign);
        if (docSnapCampaign.exists()) {
          setFbCampagneData(docSnapCampaign.data())
          setAge(docSnapCampaign.data().age)
          setGender(docSnapCampaign.data().gender)
          setCurrency(docSnapCampaign.data().currency)
          setBudget(docSnapCampaign.data().budget)
          setTypeBudget(docSnapCampaign.data().typeBudget)
          setText(docSnapCampaign.data().text)
          setLinkDesc(docSnapCampaign.data().linkDesc)
          setTitleLink(docSnapCampaign.data().titleLink)
          setSelectedInterest(docSnapCampaign.data().selectedInterst || [])
          setSelectedLocations(docSnapCampaign.data().selectedLocations || [])
          setDateDebut(docSnapCampaign.data().startAt ? handleTimestamp(docSnapCampaign.data().startAt) : null)
          setTimeDebut(docSnapCampaign.data().startAt ? handleTimestampCustom(docSnapCampaign.data().startAt) : null)
          setDateFin(docSnapCampaign.data().endAt ? handleTimestamp(docSnapCampaign.data().endAt) : null)
          setTimeFin(docSnapCampaign.data().endAt ? handleTimestampCustom(docSnapCampaign.data().endAt) : null)
          // setVisuelUrl(docSnapCampaign.data().mediaUrl)
          setMedia(docSnapCampaign.data().media)
          setSelectedAdAccount(docSnapCampaign.data().selectedAdAccount || {})
          setSelectedPage(docSnapCampaign.data().selectedPage || {})
        }
        // recupération de event


        setLoading(false);
      } catch (error) {
        console.log(error);
      }
      setLoading(false);
    })();
  }, [campaignDetailsId, userData]);

  return (
    <Page title="Campagne">
      <Container sx={{ padding: 2, bgcolor: 'white' }}>
        <Stack spacing={2} direction={'column'} alignItems={'start'} sx={{ width: '100%' }}>

          <Stack spacing={2} sx={{ paddingY: 0, borderRadius: '10px', width: '100%' }}>
            <Stack direction={'row'} spacing={2} alignItems={'center'} justifyContent={'space-between'}>
              <Stack direction={'row'} spacing={2} >
                <Box sx={{display:'flex', alignItems:'center'}}>
                  <CustomButton onClick={() => navigate(-1)} buttonText={null} type={'back'} />
                </Box>
                
                <Stack direction={'column'}>
                  <Typography variant="h4">{fbCampagneData?.name}</Typography>
                  <Stack direction={'row'} spacing={0.5}>
                    <Typography variant="caption">creé par {fbCampagneData?.name}</Typography>
                    <LucideIcon name='Dot' />
                    <Typography variant="caption">Publié le <strong>12 juillet 2025</strong></Typography>
                  </Stack>
                  
                </Stack>

              </Stack>

              <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={openMenu ? 'long-menu' : undefined}
                aria-expanded={openMenu ? 'true' : undefined}
                aria-haspopup="true"
                onClick={(e) => handleOpenMenu(e)}
                sx={{ border: '1px solid gainsboro' }}
              >
                <LucideIcon name='EllipsisVertical' />
              </IconButton>

              <StyledMenu
                id="long-menu"
                MenuListProps={{
                  'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleCloseMenu}
              >
                {
                  <MenuItem onClick={() => {
                    handleCloseMenu();
                    // handleModif(selectedIndex); // Utilise l'index sélectionné
                  }} disableRipple value={1}>
                    <Typography variant='body1'>Annuler la planification</Typography>
                  </MenuItem>
                }
                {
                  <MenuItem onClick={() => {
                    handleCloseMenu();
                    // handleOpenPlanifiedModal(selectedIndex);
                    // setOpenPlanifiedDialog(true); // Utilise l'index sélectionné
                  }} disableRipple value={1}>
                    <Typography variant='body1'>Modifier la planification</Typography>
                  </MenuItem>
                }
                {
                  <MenuItem onClick={() => {
                    handleCloseMenu();
                    //  handleModif(selectedIndex); // Utilise l'index sélectionné
                  }} disableRipple value={1}>
                    <Typography variant='body1'>Arreter la publication</Typography>
                  </MenuItem>
                }

                <MenuItem onClick={() => {
                  handleCloseMenu();
                  // setOpenDeleteDialog(true); // Utilise l'index sélectionné
                }} disableRipple value={3}>
                  <Typography variant='body1'>Supprimer</Typography>
                </MenuItem>
              </StyledMenu>
            </Stack>
          </Stack>

          <Stack my={2} direction='row' spacing={1}>
            <Box onClick={() => {
              setType(0)

            }} sx={type === 0 ? { bgcolor: '#5E17EB', color: 'white', borderRadius: '30px', cursor: 'pointer' }
              :
              { bgcolor: '#f2f2f2', borderRadius: '30px', cursor: 'pointer' }} paddingX={1.5} paddingY={1} >
              <Typography variant='caption'>Details</Typography>
            </Box>
            <Box onClick={() => {
              setType(1)

            }} sx={type === 1 ? { bgcolor: '#5E17EB', color: 'white', borderRadius: '30px', cursor: 'pointer' }
              :
              { bgcolor: '#f2f2f2', borderRadius: '30px', cursor: 'pointer' }} paddingX={1.5} paddingY={1} >
              <Typography variant='caption'>Perfommance</Typography>
            </Box>
          </Stack>
          {
            type === 0 ?
              <Sum age={age} btText={btText} linkDesc={linkDesc} media={media} selectedInterst={selectedInterst} selectedLocations={selectedLocations} />
              : <Perfs />
          }
        </Stack>

      </Container>

    </Page>

  );
};
export default CampaignDashboard;